<template>
  <div>
    <form-field type="email"
                label="Email"
                :validate="/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i"
                :required="true"
                :disabled="emailDisabled"
                v-model="entered.email"
                :focus="step === 'email'"
                @submit="step = 'givenName'">
    </form-field>
    <form-field type="text"
                label="Given name"
                :required="true"
                v-model.trim="entered.givenName"
                :focus="step === 'givenName'"
                @submit="step = 'familyName'">
    </form-field>
    <form-field type="text"
                label="Family name"
                :required="true"
                v-model.trim="entered.familyName"
                :focus="step === 'familyName'"
                @submit="submit">
    </form-field>
    <form-button pull="right" color="blue" @click="submit">
      {{submitText}}
    </form-button>
  </div>
</template>

<script>
import FormButton from '../elements/FormButton';
import FormField from '../elements/FormField';

export default {
  components: {
    FormButton,
    FormField,
  },

  data() {
    return {
      step: 'email',
      entered: {
        email: this.email,
        givenName: this.givenName,
        familyName: this.familyName,
      },
    };
  },

  props: {
    email: String,
    emailDisabled: { type: Boolean, default: false },
    givenName: String,
    familyName: String,
    submitText: { type: String, default: 'Save' },
  },

  methods: {
    submit() {
      this.step = '';

      if (!this.entered.email) {
        return this.$nextTick(() => { this.step = 'email'; });
      }

      if (!this.entered.givenName) {
        return this.$nextTick(() => { this.step = 'givenName'; });
      }

      if (!this.entered.familyName) {
        return this.$nextTick(() => { this.step = 'familyName'; });
      }

      return this.$emit('submit', {
        email: this.entered.email,
        givenName: this.entered.givenName,
        familyName: this.entered.familyName,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forms/Profile.vue